import { ButtonBase, makeStyles } from '@material-ui/core';
import { isEmpty, map } from 'lodash';
import React, { useState } from 'react';
import config from '@/configs/config';
import moment from 'moment';
import CampaignModal from './CampaignModal';

const useItemStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    background: 'white',
    borderRadius: 8,
    boxShadow: 'rgba(157,157,157,.5) 1px 1px 5px 0px',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
    height: '100%',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    padding: theme.spacing(1),
    position: 'relative',
    textAlign: 'left',
    width: '100%',
  },
  timeTag: {
    background: (props) => props.bgColor || theme.palette.campaign.main,
    borderRadius: '0 8px 8px 0',
    color: 'white',
    fontSize: 12,
    left: 0,
    padding: theme.spacing(0.5, 1.5),
    position: 'absolute',
    top: 16,
    zIndex: 1,
  },
  coverImageContainer: {
    position: 'relative',
    paddingBottom: '50%',
  },
  coverImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
  },
  name: {
    background: (props) => props.bgColor || theme.palette.campaign.main,
    borderRadius: 8,
    color: 'white',
    marginTop: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  description: {
    marginTop: theme.spacing(1),
  },
}));

function Item({ data, onClick }) {
  const {
    applcableSalesChannel,
    backgroundColor,
    coverImage,
    description,
    name,
    products,
    suitableProductDescription,
    template,
    timeRange: [startTime, endTime],
  } = data || {};
  const classes = useItemStyle({ bgColor: backgroundColor });
  const timeTagString = `${moment(startTime).utcOffset(8).format('M/D')} ~ ${moment(endTime).utcOffset(8).format('M/D')}`;

  return (
    <ButtonBase
      className={classes.root}
      onClick={() => {
        onClick({
          ...data,
          applicableChannel: applcableSalesChannel,
          description: suitableProductDescription,
          products,
          title: name,
          template,
        });
      }}
    >
      <span className={classes.timeTag}>{timeTagString}</span>
      <div className={classes.coverImageContainer}>
        <img
          alt=""
          className={classes.coverImage}
          src={`${config.RESOURCE_URI}${coverImage}`}
          onError={(e) => {
            e.currentTarget.src = `${config.RESOURCE_URI}provider_default.png`;
          }}
        />
      </div>
      <span className={classes.name}>{name}</span>
      <span className={classes.description}>{description}</span>
    </ButtonBase>
  );
}

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  name: {
    fontSize: 16,
    fontWeight: 'bold',
    padding: theme.spacing(0, 2),
  },
  description: {
    fontSize: 14,
    padding: theme.spacing(0, 2),
  },
  itemsContainer: {
    display: 'flex',
    flexShrink: 0,
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),

    '& > *': {
      padding: theme.spacing(1),
      flexBasis: '100%',

      [theme.breakpoints.up('sm')]: {
        flexBasis: '50%',
      },
    },
  },
}));

export default function MenuCampaigns({ data }) {
  const classes = useStyle();
  const [campaignModalData, setCampaignModalData] = useState({});

  console.log(campaignModalData);

  return (
    <div className={classes.root}>
      <CampaignModal
        data={campaignModalData}
        isOpened={!isEmpty(campaignModalData)}
        onClose={() => { setCampaignModalData({}); }}
      />
      <span className={classes.name}>限時特惠活動</span>
      <span className={classes.description}>期間限定特別活動！</span>
      <div className={classes.itemsContainer}>
        {map(data, (item) => {
          const { id } = item || {};

          return (
            <div className={classes.itemContainer} key={id}>
              <Item data={item} onClick={setCampaignModalData} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
